<template>
  <section
    class="bg-background-neutral-secondary border-situational-lightgrey space-y-4 divide-y rounded-2xl px-4"
  >
    <TimeRangeFilter
      :title="title"
      :state="filterState.transformedDepTime.value"
      @onUpdate="handleTimeFilterUpdate('dep', $event)"
    />
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { flightTimeFilter } from 'shared';
  import type { FlightFilterState } from '@aviata/offers-filters-fns';

  import TimeRangeFilter from './TimeRangeFilter.vue';

  const props = defineProps<{
    title: string;
    state: FlightFilterState;
  }>();

  const emit = defineEmits<{
    onTimeFilterUpdate: [flightFilterState: Partial<FlightFilterState>];
  }>();

  const filterState = flightTimeFilter.model.useFlightTimeFilter(
    computed(() => props.state),
  );

  const handleTimeFilterUpdate = (
    type: flightTimeFilter.types.FilterStateDestinationKey,
    newFlightTime: number[],
  ) => {
    const hoursInMinutes = newFlightTime.map(hour =>
      flightTimeFilter.lib.hoursToMinutes(hour),
    );

    emit('onTimeFilterUpdate', {
      [type]: {
        time: hoursInMinutes,
        airports: [],
      },
    });
  };
</script>
